import NavigationBar from "../../General/NavigationBar/NavigationBar";
import RecruitingSidebar from "../RecruitingSidebar/RecruitingSidebar";

const RecruitingLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<RecruitingSidebar />}>{children}</NavigationBar>
);

export default RecruitingLayout;
